/**
 * Created by DSadler on 02/05/2017.
 */
import React, {Component} from 'react';
import * as _ from "lodash";
import StyleItem from "./StyleItem";
//import placeHolder from './placeholder.png'
import ImageBrowser from "../../../components/ImageBrowser";

// Gets around create-react-app converting <10K files to data URI 
let placeHolder = process.env.PUBLIC_URL + "/img/placeholder.png";

class ImageItem extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      imagePickerOpen: false,
    }
  }
  render() {
    let {imageUrl, imageAlt, imageLink} = this.props.contentContent;
    
    let imgArgs = [
      this.props.styleWidth ? "width=" + _.parseInt(this.props.styleWidth) + "&": null,
      this.props.styleHeight ? "height=" + _.parseInt(this.props.styleHeight) + "&" : null,
      "mode=crop&anchor=middlecenter&upscale=false"
    ].join("");
    
    let imgSrc = imageUrl ? imageUrl + "?" + imgArgs : placeHolder;
    
    let image = (
      <img
        src={imgSrc}
        onClick={() => this.props.currentlySelected && this.setState({imagePickerOpen:true})}
        style={{
          width: imageUrl ? this.props.styleWidth : 100,
          height: imageUrl ? this.props.styleHeight : 100,
          cursor: this.props.currentlySelected ? "pointer" : null,
        }}
        alt={imageAlt || ""}
      />
    );
    
    return (
      <td
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          _.toPairs(this.props.viewAttributes).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        {this.props.currentlySelected && <ImageBrowser
          open={this.state.imagePickerOpen}
          currentImage={this.props.contentContent}
          callback={(image) => {
            this.setState({imagePickerOpen: false});
            if (image) {
              this.props.updateContent({contentContent: image});
            }
            console.log(image);
          }}
        />}
        {imageLink && <a href={imageLink}>{image}</a>}
        {!imageLink && image}
      </td>
    );
  }
}

export default ImageItem;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/ImageItem.js